// extracted by mini-css-extract-plugin
export default {"btnSubMenu":"MasterSale_btnSubMenu__baHUy"};